import { appsFlyerInit } from '@/utils/native/useAppsFlyer'

export default defineNuxtPlugin(() => {
  appsFlyerInit()
})
